export default {
	region: 'cn',	// 地区
	lang: 'sc',		// 语言
	errMsg: '网络异常，请稍后再试!'	,	//统一错误提示语
	loadingMsg: '加载中..',			//统一加载提示语
	warmTips: '温馨提示'				//温馨提示
}



// WEBPACK FOOTER //
// ./src/util/globalVar.js